import React from 'react';
import { Typography, Paper, Button } from '@mui/material';
import { AlertTriangle, RotateCcw } from 'lucide-mui';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../reducers';

interface TranscriptFailureProps {
  failureReason: string;
}

const TranscriptFailure: React.FC<TranscriptFailureProps> = () => {
  const theme = useTheme();
  const { file } = useSelector((state: RootState) => state.selectedVideo);

  const handleRetry = () => {
    if (file?.url) {
      const importUrl = `${
        window.location.origin
      }/app/#/dashboard?importUrl=${encodeURIComponent(file.url)}`;
      window.location.href = importUrl;
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 0,
      }}
    >
      <AlertTriangle
        sx={{
          fontSize: 48,
          color: theme.palette.error.main,
          mb: 2,
        }}
      />

      <Typography
        variant="h6"
        component="h2"
        sx={{
          mb: 1,
          color: theme.palette.text.primary,
          fontWeight: 500,
        }}
      >
        Transcription Failed
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 3,
          color: theme.palette.text.secondary,
          maxWidth: '600px',
          lineHeight: 1.6,
        }}
      >
        To try this again, click the button below to reimport and transcribe the
        file.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        startIcon={<RotateCcw />}
        onClick={handleRetry}
        sx={{
          textTransform: 'none',
          px: 3,
        }}
      >
        Reimport Video
      </Button>
    </Paper>
  );
};

export default TranscriptFailure;
